import { NumberFormatHelper } from "../../../../../helpers/number-format-helper";

export class ConditionalDecimalPlacesValueConverter {

  toView(value, isPercentage: boolean = false, showNAIfNoValue: boolean = false, forceNoDecimalPlaces: boolean = false,  culture?: string) {
    const absValue = Math.abs(value);

    if(value == 0 && !showNAIfNoValue) {
      return 0;
    } else if (showNAIfNoValue && value == 0){
       return 'N/A'
    }else if (absValue < 0.001 && !isPercentage && !forceNoDecimalPlaces) {
      try {
        return Number.parseFloat(absValue.toString()).toExponential(0);
      } catch (exception) {
        console.log(exception);
        return value;
      }
    } else if (absValue >= 0.001 && absValue < 1){
      return NumberFormatHelper.getFormattedValue(absValue.toString(), culture, 3, 0, "", null);
    }
    else if(absValue >= 1 && absValue < 10 && !forceNoDecimalPlaces) {
      return NumberFormatHelper.getFormattedValue(absValue.toString(), culture, 1, 0, "", null);
    } else if(isPercentage && absValue < 1 && !forceNoDecimalPlaces) {
      return NumberFormatHelper.getFormattedValue(absValue.toString(), culture, 2, 0, "", null);
    }
    else {
      return NumberFormatHelper.getFormattedValue(absValue.toString(), culture, 0, 0, "", null);
    }
  }
}
